// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"049256a0","511":"a027f980","823":"f9ae8de7"}[chunkId] + ".chunk.js";
};